import { render, staticRenderFns } from "./newsBlock.vue?vue&type=template&id=3b5c26a7&scoped=true"
import script from "./newsBlock.vue?vue&type=script&lang=js"
export * from "./newsBlock.vue?vue&type=script&lang=js"
import style0 from "./newsBlock.vue?vue&type=style&index=0&id=3b5c26a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c26a7",
  null
  
)

export default component.exports